import React from "react";
import { t } from "@auto/services";

import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";

import styles from "@src/reporting/Reporting.module.styl";

const ReportingWidget = ({
  title,
  subtitle = null,
  actions = null,
  loading = false,
  error = "",
  empty = false,
  emptyMessage = t("reporting.noDataSelectedFilters"),
  children,
  className = "",
}) => {
  const blockingLoading = loading && empty;
  const blockingError = error && empty;

  return (
    <section className={`${styles.widget} ${className}`}>
      <div className={styles.widgetHeader}>
        <div>
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {actions ? <div className={styles.widgetActions}>{actions}</div> : null}
      </div>

      {error ? <Alert severity="error" className={styles.widgetAlert}>{error}</Alert> : null}

      {blockingLoading ? (
        <div className={styles.widgetState}>
          <CircularProgress size={26} />
        </div>
      ) : null}

      {!blockingLoading && !blockingError && empty ? (
        <div className={styles.widgetState}>{emptyMessage}</div>
      ) : null}

      {!blockingLoading && !blockingError && !empty ? children : null}
    </section>
  );
};

export default ReportingWidget;
